module.exports = __webpack_public_path__ + "img/active_product4.559cc64.webp";